import { render, staticRenderFns } from "./PharmaciesBanner.vue?vue&type=template&id=3f7ebc4a"
import script from "./PharmaciesBanner.vue?vue&type=script&lang=js"
export * from "./PharmaciesBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports